import{useEffect as t}from"react";var a=(a,e)=>{t(()=>{a(e)},[e,a]),t(()=>()=>{a(!1)},[a])};export{a as useWatchEntityLoading};
//# sourceMappingURL=useWatchEntityLoading.js.map